import { axiosPrivate } from "../api/axios";
import { useEffect } from "react";
import { useLoaderData, useLocation } from "react-router-dom";
import { useLogging } from "../Shared/hooks/useLogging/useLogging";
import { NEW_ORDER_NUMBER } from "../Shared/sharedTypes/OrderInfoInterface";
import { LogLevel } from "../Shared/hooks/useLogging/Logging-types";
import { buildGiftCardPurchase, buildOrderPurchase } from "./thankYou-analytics";
import { useEcommerce } from "../Shared/hooks/useEcommerce/useEcommerce";
export const useThankYou = () => {
    var _a, _b, _c;
    const { thankYouMarkdown } = useLoaderData();
    const location = useLocation();
    const { createKlaviyoEvent, logReactPixel, logReactPixelPageView, datadogLog } = useLogging();
    const { currency, itemBrand, track } = useEcommerce();
    const orderInfo = location.state.orderInfo;
    const giftCard = location.state.giftCard;
    const isGiftCardOrder = giftCard !== undefined;
    const meals = (_a = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.days) === null || _a === void 0 ? void 0 : _a.flatMap((day) => day.meal_dates.flatMap((mealDate) => mealDate.meal_list.flatMap((meal) => {
        return {
            id: meal.ProgramMealId,
            quantity: meal.quantity,
            item_price: meal.meal_cost,
        };
    })));
    const total = (_c = (_b = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.total) !== null && _b !== void 0 ? _b : giftCard === null || giftCard === void 0 ? void 0 : giftCard.paymentAmount) !== null && _c !== void 0 ? _c : 0;
    useEffect(() => {
        logReactPixelPageView();
        if (isGiftCardOrder) {
            logReactPixel("Purchase", {
                currency: currency,
                value: total,
                content_type: "gift card",
            });
        }
        else {
            logReactPixel(orderInfo.IsSubscription ? "Subscription" : "Purchase", {
                currency: currency,
                value: total,
                contents: meals,
                content_type: "product",
            });
        }
        createKlaviyoEvent("PageView", {
            SelectedLocation: "ThankYou",
        });
        if (isGiftCardOrder) {
            createKlaviyoEvent("Purchase", {
                CurrencyType: currency,
                Total: total,
            });
        }
        else {
            createKlaviyoEvent(orderInfo.IsSubscription ? "Subscribe" : "Purchase", {
                CurrencyType: currency,
                Total: total,
            });
        }
        // GA4 keeps only the first purchase per transaction_id, so one sent with the
        // placeholder would swallow every later order's revenue. Without a real number
        // there is no confirmed order to report.
        const orderNumber = isGiftCardOrder ? giftCard.orderNumber : orderInfo.order_number;
        if (!orderNumber || orderNumber === NEW_ORDER_NUMBER) {
            datadogLog("GA4 purchase not sent: checkout returned no order number", LogLevel.WARN, { isGiftCardOrder });
            return;
        }
        // Subscriptions fire "purchase" too: GA4 only attributes revenue and dedupes by
        // transaction_id for that event. purchase_type carries the distinction instead.
        track("purchase", isGiftCardOrder
            ? buildGiftCardPurchase(giftCard, currency, itemBrand)
            : buildOrderPurchase(orderInfo, currency, itemBrand));
    }, []);
    return {
        thankYouMarkdown,
    };
};
export const ThankYouLoader = (params) => {
    return axiosPrivate
        .get(`/React/GetThankYouText?sku=${params.sku}`)
        .then((res) => res.data)
        .catch((e) => {
        console.error(e);
    });
};
